import firebase from 'firebase/compat/app';
import { getAuth } from 'firebase/auth';
import config from '../../../config/app.config';
let lock = Promise.resolve();
let isLoading = false;
const firebaseApp = firebase.initializeApp(config.firebase);
const getValidToken = (forceUpdate) => {
    return new Promise((resolve, reject) => {
        const { currentUser } = getAuth(firebaseApp);
        if (currentUser !== null) {
            resolve(currentUser);
            return;
        }
        const unsubscribe = getAuth(firebaseApp).onAuthStateChanged((user) => {
            unsubscribe();
            if (user === null) {
                reject('Not loggined');
            }
            else {
                resolve(user);
            }
        });
    }).then((user) => {
        if (forceUpdate && !isLoading) {
            isLoading = true;
            lock = new Promise((resolve, reject) => {
                user.getIdToken(true)
                    .then(() => resolve())
                    .catch(reject)
                    .finally(() => {
                    isLoading = false;
                });
            });
        }
        return lock.then(() => {
            return user.getIdTokenResult(false)
                .then((tokenResult) => {
                const { token, expirationTime } = tokenResult;
                const expirationDate = new Date(expirationTime);
                const currentDate = new Date();
                if (expirationDate.getTime() < currentDate.getTime()) {
                    return getValidToken(true);
                }
                return token;
            });
        });
    });
};
export const authenticatedRequest = (target, propertyKey, descriptor) => {
    const originalRequest = descriptor.value;
    descriptor.value = function (method, url, data, headers) {
        return new Promise((resolve, reject) => {
            getValidToken(false)
                .then((token) => {
                const authenticatedHeaders = Object.assign({}, headers, {
                    Authorization: `Bearer ${token}`
                });
                originalRequest.apply(this, [method, url, data, authenticatedHeaders])
                    .then(resolve)
                    .catch((reason) => {
                    const message = reason ? reason.message : null;
                    if (message && message.includes('JWT validation failed: TIME_CONSTRAINT_FAILURE')) {
                        resolve(descriptor.value.apply(this, [method, url, data, headers]));
                    }
                    else {
                        reject(reason);
                    }
                });
            })
                .catch(() => {
                originalRequest.apply(this, [method, url, data, headers])
                    .then(resolve)
                    .catch((reason) => {
                    const message = reason ? reason.message : null;
                    if (message && message.includes('JWT validation failed')) {
                        getAuth(firebaseApp).signOut();
                    }
                    reject(reason);
                });
            });
        });
    };
};
